import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Szoa104aRequest, Szoa104aResponse, SZOA104AService } from 'sg-api';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb122dSzoa104aService {
  /** お客さま照会結果のSubject */
  private _commonAceptSearchResult$ = new Subject<Szoa104aResponse>();

  /**
  * お客さま照会結果のobservable提供
  *
  * @readonly
  * @memberof UsedSgkb122dSzoa104aService
  */
  get valueChanges() {
    return this._commonAceptSearchResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SZOA104AService} SZOA104AService
   * @param {ApiCommonService} apiCommonService
   * @memberof UsedSgkb122dSzoa104aService
   */
  constructor(
    private sZMA301AService: SZOA104AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   * お客さま照会API呼び出し
   * @param {*} value
   * @return {*}  {Observable<Szma301Response>}
   * @memberof UsedSgkb122dSzoa104aService
   */
  searchContractor(value: Szoa104aRequest): Observable<Szoa104aResponse> {
    // 検索条件を保存
    return this.sZMA301AService.c11RSZOA104APost(<Szoa104aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkErrorNoSearchData(response);
          this.apiCommonService.checkError(response);

          this._commonAceptSearchResult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB,
            SgkbConstains.MESSAGE.APINAME_SZOA104A);
          return throwError(err.message);
        })
      );
  }
}
